<div class="main-content">
    <div class="container-fluid">
      <div style="float: right; margin-right: 20px" class="row">
      
      </div>
      <div class="clearfix"></div>
        <div class="">
             <div class="col-md-12">
                <div class="card">

                    <div class="card-body">

                      <div class="top-bar space-between">
                        <mat-select
                        style="font-weight:normal; width: auto; font-size:14px; height: 36px; display: flex;"
                          multiple
                          [(ngModel)]="selectedStatuses"
                          (selectionChange)="onStatusChange($event)"
                          class="gts-btn-select-primary"
                        >
                
                        <mat-select-trigger  class="d-flex" style="color:#9e2bb1;">
                          <span class="normal-text mr-2"> Status: </span> <span style="left:3px" class="bold-text"> {{ selectedStatuses[0] || '' }}</span> <ng-container *ngIf="selectedStatuses.length > 1">
                            <span style="padding-left:4px " >(</span><span class="bold-text">+  {{ selectedStatuses.length - 1 }}</span>)
                          </ng-container>
                          <span class="gts-btn-icon-right" style=" align-self: end">
                            keyboard_arrow_down
                            </span>
                        </mat-select-trigger>
                      
                          <mat-option
                            *ngFor="let status of statuses"
                            [value]="status.value"
                          >
                            {{ status.label }}
                          </mat-option>
                        </mat-select>
                     
                        <div style="position: relative; margin-bottom: 27px;">
                          <button
                          class="gts-btn-primary"
                          style="position: absolute; top: -5px; right: 1rem;"
                          matRipple
                          (click)="NewPaymentRequest()"
                        >
                          <span class="gts-btn-icon-left">add</span
                          ><span class="gts-btn-text"> Payment Request</span>
                        </button>
                        </div>
                      </div>
                        <hr>
                        <ngx-skeleton-loader
                        *ngIf="loading"
                        count="10"
                        appearance="line"
                        animation="pulse"
                      ></ngx-skeleton-loader>
                        <div >
                          <dinamic-table
                          *ngIf="!loading"
                          [id]="'paymentTable'"
                          [data]="listpaymment"
                          [dbname]="'paymentlist'"
                          [campoBusqueda]="campoBusqueda"
                          [perPage]="itemsPorPagina"
                          [page]="paginaActual"
                          [total_items_count]="totalItems"
                          [total_pages]="totalPaginas"
                          [config]="options"
                          [bulk]="bulk"
                          [cleanbulk]="false"
                          (buscar)="getlist($event)"
                          (action_button)="action($event)"
                          (newConfig)="updateConfig($event)"
                          [columnfilters]="filtros"
                          (rightClickAction)="handleRightClick($event)" 
                        ></dinamic-table>
                        </div>
                    </div>
                </div>
            </div>
            <!-- end col-md-12 -->
        </div>
        <!-- end row -->
    </div>
</div>
